import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoute } from "./routes/AppRoute";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


const App = () => {
  const [theme, _settheme] = useState<string>("theme_MTY");

  return (
    <>
      <I18nextProvider i18n={i18n}>
        <div>
          <BrowserRouter>
            <div className={`${theme} w-[100vw]`} id={"theme-container"}>
                <AppRoute />
            </div>
          </BrowserRouter>
        </div>
      </I18nextProvider>
    </>
  );
};

export default App;
